<div class="top-bar">

  <div #target class="absolute bottom-0 left-1/2 -translate-1/2 w-[700px] max-w-dvw"></div>

  <div class="flex flex-row gap-2 items-center py-3 max-w-[1000px] mx-auto">
    <a routerLink="/" class="block basis-[90px] shrink-0" (click)="onLogoClick()">
      <img [src]="'/assets/img/logo.svg'" class="block" [width]="90" [height]="36" alt="Sens">
    </a>
<!--    <sens-search-widget class="w-full block min-[1000px]:hidden!"/>-->
    <sens-search-widget [ref$]="target" class="w-full hidden min-[1000px]:block!"/>
  </div>
</div>

<sens-aside-bar class="aside-bar"/>

<main class="main" [class.not-an-adult]="!isUserAdult()">
  <router-outlet/>
  <sens-footer/>
</main>

<sens-bottom-bar class="bottom-bar"/>
